import cx from "clsx";
import type { JSX } from "react";

export default function FormError({
  className,
  ...props
}: JSX.IntrinsicElements["div"]) {
  return (
    <div className={cx("label text-sm text-error", className)} {...props} />
  );
}
